import React, { Component } from 'react';

class Servizi extends Component {
    render() {
      return (
  
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">Servizi</h2>
              <h3 className="section-subheading text-muted">Aiutiamo i nostri clienti creando prodotti, app e servizi on-line</h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fa fa-circle fa-stack-2x text-primary" />
                <i className="fa fa-globe fa-stack-1x fa-inverse" />
              </span>
              <h4 className="service-heading">Siti web</h4>
              <p className="text-muted">Per avere un sito web ben posizionato, con un buon traffico e un alto tasso di conversioni.</p>
            </div>
            <div className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fa fa-circle fa-stack-2x text-primary" />
                <i className="fa fa-laptop fa-stack-1x fa-inverse" />
              </span>
              <h4 className="service-heading">Mobile app</h4>
              <p className="text-muted">Per rafforzare la propria presenza digitale anche con un'app dedicata, pubblicata sui principali store.</p>
            </div>
            <div className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fa fa-circle fa-stack-2x text-primary" />
                <i className="fa fa-shopping-cart fa-stack-1x fa-inverse" />
              </span>
              <h4 className="service-heading">E-Comerce</h4>
              <p className="text-muted">Un servizio all-inclusive per gestire con la massima flessibilità il tuo magazzino, i prodotti, i prezzi, gli ordini, i pagamenti e la fatturazione</p>
            </div>
          </div>
        </div>
      );
    }
}

export default Servizi